/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import { dataSvg } from './vineyard-map.data-map';

// =============================================================================
// INTERFACES
// =============================================================================

interface IVineyardMapSvgProps {
    toggle(area: number): undefined;
    assignActiveSvg(area: number): string;
}

interface IDataSvg {
    area: number;
    path: {
        d: string;
    };
    text: {
        transform: string;
        tspan: {
            content: string;
            dy: string;
            x?: string;
        }[];
    };
}

/**
 *
 * VineyardMapSvg component: Renders vineyard areas from SVG map data and
 * toggles currently active vineyard area
 * @extends {React.Component<IVineyardMapSvgProps>}
 */

class VineyardMapSvg extends React.Component<IVineyardMapSvgProps> {

    // =========================================================================
    // PUBLIC METHODS
    // =========================================================================

    public render(): JSX.Element {
        return (
            <div className='vineyard-map-svg'>
                <svg viewBox='0 25 652 640'>
                    {
                        // obtains SVG map data
                        // renders each <g> in <svg>
                        // clicking each <g> toggles active vineyard area
                        dataSvg.map((shape: IDataSvg, shapeKey: number) => {
                            return (
                                <g
                                    className={this.props.assignActiveSvg(shape.area)}
                                    style={{animationDelay: `${shapeKey * 0.1}s`}}
                                    // tslint:disable-next-line:jsx-no-lambda react-this-binding-issue
                                    onClick={() => this.props.toggle(shape.area)}
                                    key={shapeKey}
                                >
                                    <path
                                        d={shape.path.d}
                                        transform='matrix(1,0,0,1,60,80)'
                                        style={{animationDelay: `${shapeKey * 0.05 + 3}s`}}
                                    />
                                    <text transform={shape.text.transform}>
                                        {
                                            // renders each <tspan> in <text>
                                            shape.text.tspan.map((tspan, textKey: number) => {
                                                return (
                                                    <tspan
                                                        dy={tspan.dy}
                                                        x={tspan.x ? tspan.x : undefined}
                                                        key={textKey}
                                                    >
                                                        {tspan.content}
                                                    </tspan>
                                                );
                                            })
                                        }
                                    </text>
                                </g>
                            );
                        })
                    }
                </svg>
            </div>
        );
    }
}

export default VineyardMapSvg;
